module.exports = __webpack_public_path__ + "0e2451a8c21067bbb72135bd0faa31de.svg";